// const localUrl = 'http://localhost:5002/'
// const url = localUrl
const backendUrl = 'https://dribelinebackend.onrender.com/'
// const backendUrl = 'https://dribelinebackend-dev.onrender.com/' //test env
const url=backendUrl

const tenantId = 'te_35fb4a'
// api.js
export const requestData = async (method, id, data) => {
  const fetchUrl = url + id;
  const headers = {
    'Content-Type': 'application/json',
    'X-Tenant-ID': tenantId,
  };

  const config = { method, headers };
  if (method === 'POST' || method === 'PUT') {
    config.body = JSON.stringify(data);
  }

  try {
    const response = await fetch(fetchUrl, config);

    const responseData = await response.json(); // 解析 JSON

    // 不再抛出 status 错误，而是直接返回 JSON
    return responseData;
  } catch (error) {
    console.error('RequestData error:', error);
    throw error; // 网络错误才会进入这里
  }
};

